import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { createWhyChooseUsItem } from "../../api/apiWhyChooseUs";
import parseError from "../../utils/parseError";
import { useNavigate } from "react-router-dom";

export function useCreateWhyChooseUsItem() {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const { mutate: createItemMutate, isPending } = useMutation({
        mutationFn: createWhyChooseUsItem,
        onSuccess: (response) => {
            toast.success(response.message || "Created successfully");
            queryClient.invalidateQueries({ queryKey: ["why-choose-us-items"] });
            navigate("/why-choose-us");
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to create item");
        },
    });

    return { createItemMutate, isPending };
}
